<template>
  <v-row no-gutters>
    <v-col cols="12">
      <v-skeleton-loader
        v-if="!initiated"
        ref="skeleton"
        type="table"
        class="mx-auto"
      ></v-skeleton-loader>
      <v-data-table
        v-if="initiated"
        :headers="headers"
        :items="items"
        :options.sync="options"
        :server-items-length="totalItems"
        :loading="loading"
        class="elevation-1"
        :footer-props="{
          'items-per-page-options': [30,60,100,150,250],
        }"
      >
        <template v-slot:item.invoice_status_id="{ item }">
          <v-btn x-small color="success"
                   v-if="item.invoice_status_id === 1">Paid</v-btn>
          <v-btn x-small color="warning"
                   v-if="item.invoice_status_id === 2">Pending Approval</v-btn>
          <v-btn x-small color="error"
                   v-if="item.invoice_status_id === 3">Rejected</v-btn>
          <v-btn x-small color="error"
                 v-if="item.invoice_status_id === 4">Unpaid</v-btn>
          <v-btn x-small color="error"
                 v-if="item.invoice_status_id === 5">Cancelled</v-btn>
        </template>
        <template v-slot:item.actions="{ item }">
          <v-btn x-small color="success" v-if="item.invoice_status_id === 4"
                 @click="pay(item.id)">Pay</v-btn>
          <v-btn x-small color="error" v-if="item.invoice_status_id === 4"
                 @click="cancel(item.id)">Cancel</v-btn>
          <v-btn x-small color="success" v-if="item.invoice_status_id === 4"
                 @click="paylink(item)">Pay Link</v-btn>
          <v-btn x-small color="primary" @click="view(item.id)">View</v-btn>
        </template>
      </v-data-table>
    </v-col>
  </v-row>
</template>

<script>
import { getApiBaseUrl } from '@/config/api';

export default {
  name: 'TaxInvoiceList',
  data() {
    return {
      search: '',
      initiated: false,
      productTypeId: null,
      productTypes: [],
      totalItems: 0,
      items: [],
      loading: true,
      options: {
        page: 1,
        itemsPerPage: 30,
      },
      headers: [
        { text: 'Invoice NO', value: 'invoice_no', sortable: true },
        { text: 'Invoice Date', value: 'invoice_datetime', sortable: true },
        { text: 'Subtotal', value: 'subtotal', sortable: true },
        { text: 'Tax', value: 'tax', sortable: true },
        { text: 'Discount', value: 'discount', sortable: true },
        { text: 'Total', value: 'total', sortable: true },
        { text: 'Status', value: 'invoice_status_id', sortable: false },
        { text: 'Actions', value: 'actions', sortable: false },
      ],
    };
  },
  watch: {
    options: {
      handler() {
        if (this.initiated) {
          this.loadTable();
        }
      },
      deep: true,
    },
  },
  created() {
    this.initiated = true;
    this.loadTable();
  },
  methods: {
    loadTable() {
      const {
        sortBy, sortDesc, page, itemsPerPage,
      } = this.options;
      this.loading = true;
      this.$api.post('partner/tax-invoice/list', {
        search: {
          '*': this.search,
        },
        current_page: page,
        per_page: itemsPerPage,
        product_type_id: this.productTypeId,
        order: `${sortBy}:${sortDesc}`,
      })
        .then((response) => {
          this.totalItems = response.data.total;
          this.items = response.data.data;
          this.loading = false;
        });
    },
    paylink(invoice) {
      const { brand } = this.$store.state;
      const authToken = invoice.view_token;
      const invoiceId = invoice.id;
      const { host } = window.location;

      if (host.indexOf('manage.cldy.com') === 0 || brand === 'cldy') {
        if (window.systemCurrency !== 'sgd') {
          window.open(`https://manage.cldy.com/${window.systemCurrency}/express-invoice/${invoiceId}?token=${authToken}`, '_blank');
        } else {
          window.open(`https://manage.cldy.com/express-invoice/${invoiceId}?token=${authToken}`, '_blank');
        }
      } else if (host.indexOf('manage.qoxy.com') === 0 || brand === 'qoxy') {
        window.open(`https://manage.qoxy.com/express-invoice/${invoiceId}?token=${authToken}`, '_blank');
      } else {
        window.open(`/${brand}/express-invoice/${invoiceId}?token=${authToken}`, '_blank');
      }
    },
    view(invoiceId) {
      const authToken = window.btoa(this.$store.state.user.auth_token);
      window.open(`${getApiBaseUrl()}/v1/customer/tax-invoice/${invoiceId}/view?system_currency=${window.systemCurrency}&auth_token=${authToken}`, '_blank');
    },
    download(invoiceId) {
      const authToken = window.btoa(this.$store.state.user.auth_token);
      window.open(`${getApiBaseUrl()}/v1/customer/tax-invoice/${invoiceId}/download?system_currency=${window.systemCurrency}&auth_token=${authToken}`, '_blank');
    },
    cancel(invoiceId) {
      /* eslint-disable no-alert */
      const r = window.confirm('Are you sure to cancel this invoice?');
      if (r === true) {
        this.$api.post(`partner/tax-invoice/${invoiceId}/cancel`, {})
          .then(() => {
            this.$store.dispatch('addAlert', {
              id: Date.now(),
              type: 'success',
              message: 'Invoice is cancelled successfully.',
            });

            this.loadTable();
          });
      }
    },
    pay(invoiceId) {
      this.$router.push({ name: 'Retail.InvoiceDetail', params: { id: invoiceId } })
        .catch(() => {
        });
    },
  },
};
</script>

<style scoped>

</style>
